import { render, staticRenderFns } from "./Measurements.vue?vue&type=template&id=6da0f92a&"
import script from "./Measurements.vue?vue&type=script&lang=js&"
export * from "./Measurements.vue?vue&type=script&lang=js&"
import style0 from "./Measurements.vue?vue&type=style&index=0&id=6da0f92a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports